import { httpClient } from '../http';
import { MutationRequest, NoContent } from '../types';
import {
	AdminDeviceResponse,
	BasicDeviceResponse,
	CreateDeviceRequest,
	RefreshDeviceTokenResponse,
	UpdateDeviceNameRequest,
	UpdateDeviceRequest,
} from './types';

export const createDevice = async ({
	request,
	formKey,
}: MutationRequest<CreateDeviceRequest>): Promise<AdminDeviceResponse> => {
	const { data } = await httpClient.post<AdminDeviceResponse>('/devices', request, {
		headers: { formKey },
	});

	return data;
};

export const updateDevice = async (
	id: string,
	{ request, formKey }: MutationRequest<UpdateDeviceRequest>
): Promise<AdminDeviceResponse> => {
	const { data } = await httpClient.patch<AdminDeviceResponse>(`/devices/${id}`, request, {
		headers: { formKey },
	});

	return data;
};

export const updateDeviceName = async (
	id: string,
	{ request, formKey }: MutationRequest<UpdateDeviceNameRequest>
): Promise<BasicDeviceResponse> => {
	const { data } = await httpClient.patch<BasicDeviceResponse>(`/devices/${id}/name`, request, {
		headers: { formKey },
	});

	return data;
};

export const deleteDevice = async (id: string): Promise<NoContent> => {
	const { data } = await httpClient.delete<NoContent>(`/devices/${id}`);

	return data;
};

export const refreshDeviceToken = async (id: string): Promise<RefreshDeviceTokenResponse> => {
	const { data } = await httpClient.post<RefreshDeviceTokenResponse>(`/devices/${id}/refresh-token`);

	return data;
};
